/** Defines all routes with appropriate permissions
 * to be used on both the Router as well as toggling
 * visibility of navbar and dashboard buttons
 **/

import { Permissions } from '@constants/permissions'

export const RoutePermissions = {
  '/reports': [Permissions.ACCOUNTANT, Permissions.PROJECT_MANAGER, 'reports_view'],
  '/todays-reports': [Permissions.PROJECT_MANAGER, 'reports_view'],
  '/lock-reports': [Permissions.ACCOUNTANT, 'reports_edit'],
  '/locked-reports': [
    Permissions.ACCOUNTANT,
    Permissions.PROJECT_MANAGER,
    Permissions.DISPATCHER,
    'reports_view'
  ],
  '/my-reports': [Permissions.FOREMAN, Permissions.PROJECT_MANAGER, 'reports_view'],
  '/dispatcher-reports': [Permissions.DISPATCHER, 'reports_view'],
  '/invalid-reports': [Permissions.ACCOUNTANT, 'reports_edit'],
  '/locations': [Permissions.FOREMAN, Permissions.PROJECT_MANAGER],
  '/jobs': [Permissions.FOREMAN, Permissions.PROJECT_MANAGER, Permissions.ACCOUNTANT],
  '/scheduler': [Permissions.SCHEDULER_EDIT, Permissions.SCHEDULER_VIEW],
  '/dispatcher': [Permissions.DISPATCHER],
  '/dispatcher/:date?': [Permissions.DISPATCHER],
  '/dispatcher/:date/:assetType': [Permissions.DISPATCHER],
}
